class CountUp {
  constructor(el) {
    this.el = el;
    const items = document.querySelectorAll("." + this.el);
    this.initObserver(items);
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    animateAgeBlock();
    animateMidCareer();
  }

  initObserver(items) {
    const options = { threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      this.shuffleNumberCounter(entries);
    }, options);

    items.forEach(target => observer.observe(target));
  }

  shuffleNumberCounter(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains("is-visible")) {
        const el = entry.target;

        const from = Number(el.dataset.from || 0);
        const to = Number(el.dataset.to || 0);
        const duration = Number(el.dataset.duration) || 1500;

        if (!Number.isFinite(from) || !Number.isFinite(to)) return;
        if (from > to) return;

        const increment = to - from;
        const decimalPointLength = getDecimalPointLength(increment);
        const startTime = performance.now();

        const countUp = () => {
          const elapsed = performance.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          let current = (from + progress * increment).toFixed(decimalPointLength);

          el.innerHTML = formatWithSmall(current);

          if (progress < 1) {
            requestAnimationFrame(countUp);
          } else {
            el.innerHTML = formatWithSmall(to);
          }
        };

        requestAnimationFrame(countUp);
        el.classList.add("is-visible");
      }
    });
  }
}

function getDecimalPointLength(number) {
  const str = number.toString();
  const index = str.indexOf(".");
  return index === -1 ? 0 : str.length - index - 1;
}

function formatWithSmall(value) {
  const num = Number(value);
  if (isNaN(num)) return value;

  const str = value.toString();

  if (!str.includes(".")) {
    return num.toLocaleString("ja-JP");
  }

  const [intPart, decPart] = str.split(".");

  const intFormatted = Number(intPart).toLocaleString("ja-JP");

  if (!decPart || Number(decPart) === 0) {
    return intFormatted;
  }

  return `${intFormatted}<small>.${decPart}</small>`;
}

function animateAgeBlock() {
  const block = $(".c-data-item-age");
  let done = false;

  $(window).on("scroll", function () {
    if (done) return;

    const rect = block[0].getBoundingClientRect();
    const wh = window.innerHeight;

    if (rect.top < wh * 0.8) {
      done = true;
      runAnimationSequence(block);
    }
  });

  function runAnimationSequence($block) {
    const graph = $block.find(".graph");

    $({ p: 0 }).animate({ p: 1 }, {
      duration: 1500,
      easing: "swing",
      step: function (now) {
        graph.css("--p", now);
      },
      complete: function () {
        showLines(graph);
      }
    });

    $block.find(".js-count-up").each(function () {
      const $num = $(this);
      const from = Number($num.data("from") || 0);
      const to = Number($num.data("to"));
      const duration = Number($num.data("duration") || 1000);

      $({ val: from }).animate({ val: to }, {
        duration: duration,
        easing: "swing",
        step: function (now) {
          $num.text(now.toFixed(1));
        },
        complete: function () {
          $num.text(to % 1 === 0 ? to : to.toFixed(1));
        }
      });
    });
  }

  function showLines($graph) {
    $graph.find(".line").css({
      height: "50%",
      opacity: 1
    });
  }
}

function animateMidCareer() {
  const block = $(".c-data-item-midcareer");
  let done = false;

  $(window).on("scroll", function () {
    if (done) return;

    const rect = block[0].getBoundingClientRect();
    const wh = window.innerHeight;

    if (rect.top < wh * 0.8) {
      done = true;
      runBarGraphAnimation(block);
    }
  });

  function runBarGraphAnimation($block) {
    const items = $block.find(".bar-graph li");

    items.each(function () {
      const $line = $(this).find(".line");
      const targetWidth = $(this).css("--target-width");
      $line.css("width", targetWidth);
    });

    setTimeout(function () {
      $block.find(".js-count-up").each(function () {
        const $num = $(this);
        const from = Number($num.data("from") || 0);
        const to = Number($num.data("to"));
        const duration = Number($num.data("duration") || 1000);

        $({ val: from }).animate({ val: to }, {
          duration: duration,
          easing: "swing",
          step: function (now) {
            const v = now.toFixed(1);
            $num.html(formatWithSmallDecimal(v));
          },
          complete: function () {
            const finalValue = (to % 1 === 0) ? to : to.toFixed(1);
            $num.html(formatWithSmallDecimal(finalValue));
          }
        });
      });
    }, 250);
  }
}


function formatWithSmallDecimal(value) {
  const str = value.toString();

  if (!str.includes(".")) {
    return str;
  }

  const [intPart, decPart] = str.split(".");
  return `${intPart}<small>.${decPart}</small>`;
}